import React from 'react';
import { useWindowSize } from 'utils/useWindowSize';
import RequestsListPage from './requests-list';
import MobileRequestsContainer from './mobile-requests-container';
import { RouteComponentProps } from 'react-router';

export interface RequestsListContainerProps extends RouteComponentProps {}

const RequestsListContainer: React.FC<RequestsListContainerProps> = ({ location, match, history }) => {
  const { width } = useWindowSize();
  const isMobile = width < 768; // Punto de quiebre para móviles
  return isMobile ? (
    <MobileRequestsContainer history={history} location={location} match={match} />
  ) : (
    <RequestsListPage history={history} location={location} match={match} />
  );
};

export default RequestsListContainer;
